import React from 'react'
import { MarketplaceListItem } from './MarketplaceListItem'
import { IResourceWithFiles } from '../../../interfaces/services/resources.interfaces'

interface MarketplaceListProps {
  resources: IResourceWithFiles[]
}

export const MarketplaceList = ({
  resources,
}: MarketplaceListProps): JSX.Element => {
  return (
    <div className="w-full space-y-4">
      {resources.map((_resource) => (
        <MarketplaceListItem key={_resource._id} resource={_resource} />
      ))}
    </div>
  )
}
